import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export class SsoController {
  static $inject = [];
}

export const AuthSsoControllerModule = angular
  .module('acme.view.auth.sso.controllers.sso', [uiRouter])
  .controller('SsoController', SsoController).name;
